import { BranchModel } from "@WhiteCap/Services/ContactUsLocationsService";

export interface BranchesState {
    branches: BranchModel[];
    isLoading: boolean;
    error?: string;
}

const initialState: BranchesState = {
    branches: [],
    isLoading: false,
    error: undefined,
};

export default function reducer(state: BranchesState = initialState, action: any): BranchesState {
    switch (action.type) {
        case "Custom/Branches/BeginLoadBranches":
            return {
                ...state,
                isLoading: true,
                error: undefined,
            };

        case "Custom/Branches/CompleteLoadBranches":
            return {
                ...state,
                isLoading: false,
                branches: action.result?.branches || [],
            };

        case "Custom/Branches/FailedLoadBranches":
            return {
                ...state,
                isLoading: false,
                error: "Failed to load branches",
            };

        default:
            return state;
    }
}
